module monitoringApp.controllers {
    class LogViewController {
        public allDate;


        constructor() {
            var self = this;

            this.browserLog();
            this.networkLog();

        }

        private browserLog = () => {
            let self = this;
            let html = "";
            //@ts-ignore
            if(typeof browserLog != "undefined"){
                //@ts-ignore
                $.each(browserLog, function (index, log) {
                    html +=self.createBrowserLogHtml(log, index);
                });

                setTimeout(function () {
                    $('#browserLog').append(html);
                }, 200);
            }
        };

        private createBrowserLogHtml(log, index){
            let html = '<div class="row">\n' +
                '            <div class="log-content">\n' +
                '              <div class="log-content-header '+this.getLogLevelClassName(log.level)+'">\n' +
                '                <div class="col-2"><p>'+this.getDate(log.timestamp)+'</p></div>\n' +
                '                <div class="col-8"><p><b>'+this.getLogMessage(log.message)+'</b></p></div>\n' +
                '                <div class="col-2"><p>'+log.source+'</p></div>\n' +
                '              </div>\n' +
                '              <div class="log-content-description '+this.getLogLevelClassName(log.level)+'" data-content-id="'+index+'">\n' +
                '                <div class="col-10"><p>'+this.getLogUrl(log.message)+'</p></div>\n' +
                '                <div class="col-2"><p>'+this.getLogLocal(log.message)+'</p></div>\n' +
                '              </div>\n' +
                '            </div>\n' +
                '          </div>';

            return html;
        }

        private getLogLevelClassName(level){
            switch (level) {
                case "SEVERE":
                    return 'error';
                    break;
                case "INFO":
                    return 'info';
                    break;
                default:
                    return '';
            }
        }
        private getLogMessage(message){
            var urlEndPosition = message.indexOf(' ');
            var locationEndPosition = message.indexOf(' ', urlEndPosition+1);
            var endPosition = message.length;
            return message.slice(locationEndPosition+1,endPosition-1).replace('"', '');
        }
        private getLogLocal(message){
            var urlEndPosition = message.indexOf(' ');
            var locationEndPosition = message.indexOf(' ', urlEndPosition+1);
            var endPosition = message.length;
            return message.slice(urlEndPosition+1,locationEndPosition);
        }
        private getLogUrl(message){
            var urlEndPosition = message.indexOf(' ');
            return message.slice(0,urlEndPosition);
        }
        private getDate(timestamp){
            //@ts-ignore
            let date = moment(new Date(timestamp)).format("YYYY-MM-DD hh:mm:ss.SSS");

            return date;
        }

        private networkLog = () => {
            let self = this;
            let html = "";
            //@ts-ignore
            if(typeof networkLog != "undefined"){
                //@ts-ignore
                $.each(networkLog, function (index, log) {
                    console.log(log, log.name);
                    html += self.createNetworkLogHtml(log);
                });

                setTimeout(function () {
                    $('#networkLog').append(html);
                }, 200);
            }
        };

        private createNetworkLogHtml(log){
            let html = '<div class="row">\n' +
                '            <div class="log-content">\n' +
                '              <div class="log-content-header">\n' +
                '                <p><b>'+this.getLogFileName(log.name)+'</b></p>\n' +
                '              <div class="response" style="left: '+((log.startTime/10)+350)+'px; width: '+(log.duration)/10+'px;"></div>' +
                '              </div>\n' +
                '              <div class="log-content-description">\n';
                html +='<div class="col-12"><p><b>name</b>: '+log.name+'</p></div>\n';

            $.each(log, function (index, l) {
                                    if(index === 'name' || index === 'serverTiming'){
                                    }else{
                                        html +='<div class="col-2"><p><b>'+index+'</b>: '+l+'</p></div>\n';
                                    }
                                });
                html +='              </div>\n' +
                '            </div>\n' +
                '          </div>';

            return html;
        }


        private getLogFileName(url){
            var filePositionStartn = url.lastIndexOf('/');
            var filePositionEnd = url.indexOf('?');
            var endPosition = url.length;
            if(url.slice(filePositionStartn+1, filePositionEnd>0 ? filePositionEnd: endPosition)==0){
                return url.slice(0, 20);
            }else{
                return url.slice(filePositionStartn+1, filePositionEnd>0 ? filePositionEnd: endPosition);
            }
        }





    }

    angular.module("ultimateMonitoringApp").controller("logViewController", LogViewController);
}